<template>
  <div class="box12">
    <pageTitle title="真实学员评价" titleColor="#191c47" />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="#9ecfff"
      blockColor="#0181ff"
    />
    <!-- <div class="txt">
      * 资料来源：博学谷软件测试学科班主任老师与同学们的日常沟通截图
    </div> -->
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/cPuls/box12/4.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/cPuls/box12/8.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/cPuls/box12/3.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/cPuls/box12/7.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/cPuls/box12/2.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/cPuls/box12/5.png"),
              id: 6,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/cPuls/box12/1.png"),
              id: 7,
            },
            {
              img: require("../../../assets/coursePage/cPuls/box12/6.png"),
              id: 8,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.053333rem solid #9ecfff;",
        imgHoverBorder: "border: 0.053333rem solid #0181ff;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  padding: 80px 0 88px;
  width: 100%;
  font-size: 4px;
  .txt {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #b9c8d9;
    line-height: 20px;
    text-align: center;
    margin-top: 70px;
  }
}
</style>
